import { render, staticRenderFns } from "./orderCreate3.vue?vue&type=template&id=ed956a70&scoped=true"
import script from "./orderCreate3.vue?vue&type=script&lang=js"
export * from "./orderCreate3.vue?vue&type=script&lang=js"
import style0 from "./orderCreate3.vue?vue&type=style&index=0&id=ed956a70&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed956a70",
  null
  
)

export default component.exports